var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('span',{staticClass:"item",on:{"click":_vm.btnclick}},[_vm._v("修改")]),_c('span',{staticClass:"item",on:{"click":_vm.btnclick}},[_vm._v("修改")])])
}
var staticRenderFns = []

export { render, staticRenderFns }